import React                      from 'react'
import { Button
       , Layout
       , Menu }                   from 'antd'
import { Observer }               from 'mobx-react'

import { TEXT
       , tr }                     from '../00_assets'
import { API
       , kde_api_mastering_t }     from '../02_api'
import { avoid_closing_modal
       , EditButtons
       , ModalPrompt }            from '../10_ui'

import { MKeyMastering }           from './01_screen_key_mastering_model'
import { create_mastering_editor_model
       , MasteringEditor }         from './02_screen_key_mastering_editor'


export const MasteringList: React.FC = () =>
<Observer render={ ( ) =>
{
  const model     = MKeyMastering.instance( )
      , masterings = model.masterings
      , on_select_mastering = (sel:any) =>
          model.selected_mastering = parseInt( sel.key, 10 )
      , on_delete = async ( row: kde_api_mastering_t ) =>
          model.data.on_delete( row )
      , on_create = ( ) =>
        {
            const editor_model = create_mastering_editor_model( ) ;

            ModalPrompt( tr( TEXT.KEY_MASTERING_NEW_TITLE )
                      , <MasteringEditor form={ editor_model } />
                      , async ( ) =>
                        {
                          if ( editor_model.has_errors( ) )
                               avoid_closing_modal( ) ;
                          else
                            {
                               await API.create_mks( editor_model.fields( ) ) ;
                               model.data.data_fetcher.reload_cur_page( ) ;
                            }
                        }
                      , "plus"
                      , tr( TEXT.UI_BUTTON_CREATE )
                      ) ;
        }

  return <Layout.Sider className="bg-bg scrollable" width={240}>
     <div className="flex-row flex-align-center p-3">
       <Button
         type="primary"
         className="w-100"
         onClick={ on_create }
         disabled={ masterings.loading }
         icon="upload"
       >
         { tr( TEXT.KEY_MASTERING_NEW_TITLE ) }
       </Button>
     </div>
     <Menu
        mode="inline"
        selectedKeys={[model.selected_mastering + '']}
        style={{ lineHeight: '64px' }}
        onSelect={ on_select_mastering }
      >
        {
          masterings.data.map( entry =>
            <Menu.Item key={ entry.id } className="on-hover">
              <EditButtons
                row={ entry }
                hideEdit={ true }
                onEdit={ ( ) => { } }
                onDelete={ on_delete }
              />
              { entry.name }
            </Menu.Item> )
        }
      </Menu>
     </Layout.Sider>
}} /> ;
